import axios, { AxiosRequestConfig } from "axios";

async function uploadImage(
  csrfToken: string,
  file: File,
  updatePercentage: (percentage: number) => void,
  finished: (imagePath: string) => void,
) {
  const config = { headers: { "X-CSRF-TOKEN": csrfToken } };
  axios
    .post("/signatures", { signature: { filename: file.name } }, config)
    .then((response) => {
      let url = response.data.url;
      let imagePath = response.data.key;

      const config: AxiosRequestConfig = {
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total === undefined) {
            return;
          }

          let percentCompleted = Math.floor(
            (progressEvent.loaded * 100) / progressEvent.total,
          );

          updatePercentage(percentCompleted);
        },
      };

      axios
        .put(url, file, config)
        .then((response) => {
          finished(imagePath);
        })
        .catch((error) => {
          console.error(error);
        });
    })
    .catch((error) => {
      console.error(error);
    });
}

export default uploadImage;
